<template>
  <section>
    <div class="wrapper">
      <SideBar />
      <div class="main-panel">
        <Header />
        <div class="content">
          <slot />
        </div>
        <Footer />
      </div>
    </div>
    <!-- <NoLoginHeader /> -->
  </section>
</template>

<script>
import Header from "@/components/layout/admin/Header.vue";
import SideBar from "@/components/layout/admin/Sidebar.vue";
import Footer from "@/components/layout/admin/Footer.vue";
import $ from "jquery";

export default {
  name: "MainLayout",
  components: {
    Header,
    SideBar,
    Footer
  },
  
  mounted() {
    var navbar_initialized = false;
    var lbd = {
      misc: {
        navbar_menu_visible: 0
      },

      checkSidebarImage: function() {
        var $sidebar = $(".sidebar");
        var image_src = $sidebar.data("image");

        if (image_src !== undefined) {
          var sidebar_container =
            '<div class="sidebar-background" style="background-image: url(' +
            image_src +
            ') "/>';
          $sidebar.append(sidebar_container);
        }
      },

      initRightMenu: debounce(function() {
        if (!navbar_initialized) {
          var $sidebar_wrapper = $(".sidebar-wrapper");
          var $navbar = $("nav")
            .find(".navbar-collapse")
            .html();

          // var mobile_menu_content = "";

          var nav_content = $navbar;

          nav_content =
            '<ul class="nav nav-mobile-menu">' + nav_content + "</ul>";

          // navbar_form = $('nav').find('.navbar-form').get(0).outerHTML;

          var $sidebar_nav = $sidebar_wrapper.find(" > .nav");

          // insert the navbar form before the sidebar list
          var $nav_content = $(nav_content);
          // $navbar_form = $(navbar_form);
          $nav_content.insertBefore($sidebar_nav);
          // $navbar_form.insertBefore($nav_content);

          $(".sidebar-wrapper .dropdown .dropdown-menu > li > a").click(
            function(event) {
              event.stopPropagation();
            }
          );
        } else {
          if ($(window).width() > 991) {
            $sidebar_wrapper.find(".nav-mobile-menu").remove();
          }
        }
      }, 200)
    };

    function debounce(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this,
          args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        }, wait);
        if (immediate && !timeout) func.apply(context, args);
      };
    }

    $(document).on("click", ".navbar-toggle", function() {
      var $toggle = $(this);
      if (lbd.misc.navbar_menu_visible == 1) {
        $("html").removeClass("nav-open");
        $("html").addClass("nav-close");
        lbd.misc.navbar_menu_visible = 0;
        $("#bodyClick").remove();
        setTimeout(function() {
          $toggle.removeClass("toggled");
        }, 550);
      } else {
        setTimeout(function() {
          $toggle.addClass("toggled");
        }, 580);
        var div = '<div id="bodyClick"></div>';
        $(div)
          .appendTo("body")
          .click(function() {
            $("html").removeClass("nav-open");
            $("html").addClass("nav-close");
            lbd.misc.navbar_menu_visible = 0;
            setTimeout(function() {
              $toggle.removeClass("toggled");
              $("#bodyClick").remove();
            }, 550);
          });

        $("html").addClass("nav-open");
        $("html").removeClass("nav-close");
        lbd.misc.navbar_menu_visible = 1;
      }
    });

    $(function() {
      var path = window.location.href;
      $(".sidebar .nav li > a").each(function() {
        if (this.href === path) {
          $(this)
            .parent()
            .addClass("active");
        }
      });
      $(".sidebar .nav li ul li > a").each(function() {
        if (this.href === path) {
          $(this).addClass("active");
        }
      });
    });
  }
};
</script>
